import { EditorItem } from '../../store/editorStore';

type ImageItemContentProps = {
  item: EditorItem;
};

export function ImageItemContent({ item }: ImageItemContentProps) {
  const style = item.style as any;
  
  // Xử lý hiển thị viền ô chứa
  const borderStyle = style.borderWidth && style.borderWidth > 0
    ? `${style.borderWidth}px solid ${style.borderColor || '#000'}`
    : 'none';
  
  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      border: borderStyle,
      overflow: 'hidden'
    }}>
      <img
        src={item.content}
        alt="Thumbnail element"
        style={{ 
          width: '100%', 
          height: '100%', 
          objectFit: style.objectFit || 'contain',
          pointerEvents: 'none',
          backgroundColor: style.removeBackground ? style.backgroundColor || 'transparent' : undefined
        }}
      />
    </div>
  );
} 